import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Alert,
	Card,
	CardBody,
	Col,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Row,
	Spinner,
	UncontrolledDropdown,
} from 'reactstrap';
import { createSelector } from 'reselect';
import { filesize } from 'filesize';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import {
	getFolders as onGetFolders,
	updateFolder as onUpdateFolder,
	deleteFolder as onDeleteFolder,
	addNewFolder as onAddNewFolder,
	deleteFile as onDeleteFile,
} from '../../slices/thunks';
import { CreateRenameFolderModal } from './CreateRenameFolderModal';
import SimpleBar from 'simplebar-react';
import { Files } from './Files';
import { color } from 'echarts';
import { set } from 'lodash';
import { LoadingOverlay } from '@mantine/core';

export const Folders = props => {
	const {
		current_folder,
		setCurrent_Folder,
		establishmentId
	} = props;

	const dispatch = useDispatch();

	const [folder, setFolder] = useState(null);
	const [isLoadingFolders, setIsLoadingFolders] = useState(false);
	const [has_folders, setHasFolders] = useState(false);
	const [modalCreateFolder, setModalCreateFolder] = useState(false);
	const [isEdit, setIsEdit] = useState(false);


	// const selectFileManagerState = state => state.FileManager;
	// const selectFileManagerProperties = createSelector(
	// 	selectFileManagerState,
	// 	state => ({
	// 		folders: state.folders,
	// 		isLoadingFolder: state.isLoadingFolder
	// 	})
	// );

	// const { folders, isLoadingFolder } = useSelector(selectFileManagerProperties);

	const selectorFolder = createSelector(
		state => state.FileManager,
		result => ({
			folders: result.folders,
		})
	);

	const { folders } = useSelector(selectorFolder);

	useEffect(() => {
		setIsLoadingFolders(true);
		dispatch(
			onGetFolders({
				folder_id: current_folder?._id || '/',
				establishment_id: establishmentId
			})
		).finally(() => setIsLoadingFolders(false));
	}, [
		current_folder,
		establishmentId
	]);

	useEffect(() => {
		setHasFolders(folders && folders.length > 0);
	}, [folders]);

	const folderToggle = useCallback(() => {
		if (modalCreateFolder) {
			setModalCreateFolder(false);
			setFolder(null);
		} else {
			setModalCreateFolder(true);
		}
	}, [modalCreateFolder]);

	// Add Folder
	const handleCreateFolder = () => {
		setModalCreateFolder(!modalCreateFolder);
		setIsEdit(false);
	};

	// Delete Folder
	const onClickFolderDelete = folder => {
		setFolder(folder);
		setDeleteModal(true);
	};

	const handleDeleteFolder = () => {
		if (deleteAlt) {
			if (folder) {
				dispatch(onDeleteFolder(folder.id));
				setDeleteModal(false);
				setDeleteAlt(false);
			}
		} else {
			if (file) {
				dispatch(onDeleteFile(file.id));
				setDeleteModal(false);
				sidebarClose('file-detail-show');
			}
		}
	};

	// Folder validation
	const folderValidation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			name: folder?.name || '',
			parent_folder: folder?.parent_folder || '/',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Ingrese el nombre de la carpeta'),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updateFolder = {
					name: values?.name || '',
					parent_folder: folder?.parent_folder || '/',
				};
				// save edit Folder
				dispatch(
					onUpdateFolder({
						id: folder._id,
						updateFolder,
					})
				).finally(() => {
					setModalCreateFolder(!modalCreateFolder);
					setFolder(null);
					setIsEdit(false);
					folderValidation.resetForm();
				});
			} else {
				const newFolder = {
					name: values.name,
					parent_folder: current_folder?._id || '/',
				};
				// save new Folder
				dispatch(onAddNewFolder(newFolder)).finally(() => {
					setModalCreateFolder(!modalCreateFolder);
					folderValidation.resetForm();
				});
			}
		},
	});

	console.log(folders)

	return (
		<div id='folder-list' className='mb-2'>
			{folders && folders.length > 0 && (
				<Row className='justify-content-beetwen g-2 mb-3'>
					<Col></Col>
					<Col className='col-auto'>
						<div className='d-flex gap-2 align-items-start'>
							<button
								className='btn btn-label btn-primary'
								onClick={() => handleCreateFolder()}
							>
								<i className='ri-folder-add-line label-icon'></i>
								Crear Carpeta
							</button>
						</div>
					</Col>
				</Row>
			)}

			<div
				style={{
					position: 'relative',
				}}
			>
				<LoadingOverlay visible={isLoadingFolders} opacity={0.5} />
				<Row id='folderlist-data'>
					{folders && folders.length > 0 ? (
						<SimpleBar
							style={{ maxHeight: '350px' }}
							className='pe-2'
						>
							<Row className='m-0 p-0'>
								{folders.map((item, key) => (
									<Col key={key} className='col-1 p-0' style={{ margin: '5px' }}>
										<Card
											className='shadow-none card-height-100 h-100 m-0'
											id={'folder-' + item._id}
											onClick={() => setCurrent_Folder(item)}
											style={{ cursor: 'pointer' }}
										>
											<CardBody className='bg-light' style={{ padding: '5px' }}>
												<div className='d-flex'>
													<div className='form-check form-check-danger fs-15 flex-grow-1'>
														<input
															className='form-check-input'
															type='checkbox'
															value=''
															id={
																'folderlistCheckbox_' +
																item._id
															}
															onClick={e =>
																e.stopPropagation()
															}
														/>
														<label
															className='form-check-label'
															htmlFor={
																'folderlistCheckbox_' +
																item._id
															}
														></label>
													</div>

													<UncontrolledDropdown>
														<DropdownToggle
															tag='button'
															className='btn btn-ghost-primary btn-icon btn-sm dropdown'
															onClick={e =>
																e.stopPropagation()
															}
														>
															<i className='ri-more-2-fill fs-16 align-bottom' />
														</DropdownToggle>
														<DropdownMenu className='dropdown-menu-end'>
															<DropdownItem
																className='edit-folder-list'
																onClick={e => {
																	e.stopPropagation();
																	setFolder(item);
																	setIsEdit(true);
																	setModalCreateFolder(
																		!modalCreateFolder
																	);
																}}
															>
																Renombrar
															</DropdownItem>
															<DropdownItem
																onClick={e => {
																	e.stopPropagation();
																	setFolder(item);
																	onClickFolderDelete(
																		item
																	);
																	setDeleteAlt(true);
																}}
															>
																Eliminar
															</DropdownItem>
														</DropdownMenu>
													</UncontrolledDropdown>
												</div>

												<div className='text-center'>
													<div className='m-0'>
														<i className='ri-folder-2-fill align-bottom text-warning display-6'></i>
													</div>
													<h6 className='fs-11 folder-name'>
														{item.name}
													</h6>
												</div>
												<div className='hstack fs-10 text-muted'>
													<span className='me-auto'>
														<b>{item.files_count}</b>{' '}
														Archivos
													</span>
													<span>
														<b>
															{filesize(item.size || 0)}
														</b>
													</span>
												</div>
											</CardBody>
										</Card>
									</Col>
								))}
							</Row>
						</SimpleBar>
					) : null}
				</Row>
			</div>

			<Row id='filelist-data' className={has_folders ? 'mt-4' : ''}>
				<Files
					current_folder={current_folder}
					has_folders={has_folders}
					handleCreateFolder={handleCreateFolder}
				/>
			</Row>

			<CreateRenameFolderModal
				isOpen={modalCreateFolder}
				setIsOpen={setModalCreateFolder}
				isEdit={isEdit}
				form={folderValidation}
				setFolder={setFolder}
			/>
		</div>
	);
};
